import { render, staticRenderFns } from "./SidebarItemTooltip.vue?vue&type=template&id=0b7a1208"
import script from "./SidebarItemTooltip.vue?vue&type=script&lang=js"
export * from "./SidebarItemTooltip.vue?vue&type=script&lang=js"
import style0 from "./SidebarItemTooltip.vue?vue&type=style&index=0&id=0b7a1208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports